import { z } from "zod";
import { createSelectValidator } from "../Inputs/Utils/createSelectValidator";

export const CategorySchema = z.object({
    category: createSelectValidator(
        z.string().min(1, "Category is required"),
        "Category is required"
    ).optional()
})

// This is specifcially for the project category (ie. 3P, SI, NC)
export const ProjectCategorySchema = z.object({
    category: createSelectValidator(
        z.enum(["3P", "SI", "FP", "Bid"]),
        "Category is required"
    )
})